import React from "react"
import { EventsItem } from "./render-evenements-styled"
import {
  eventsItem,
  eventsCarousel,
  eventsCarouselArrowRight,
  eventsCarouselArrowLeft,
  eventsCarouselDotsWrapper,
} from "../agenda.module.scss"
import PropTypes from "prop-types"
import EvenementContent from "../EvenementContent/evenement-content"
import MultiCarousel from "react-multi-carousel"
import {
  carouselArrowRight,
  carouselArrowLeft,
} from "../../../Transformers/CarouselTransformer/carousel-transformer.module.scss"
import { CustomArrows } from "../../Carousel/custom-arrow-styled"

const RenderEvenements = ({ eventsData }) => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 900 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 900, min: 0 },
      items: 1,
    },
  }

  return (
    <>
      <MultiCarousel
        className={eventsCarousel}
        transitionDuration={500}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<CustomLeftArrow />}
        dotListClass={eventsCarouselDotsWrapper}
        showDots={true}
        responsive={responsive}
        infinite={true}
        arrows={true}
        autoPlay={true}
        autoPlaySpeed={5000}
        shouldResetAutoplay={false}
        renderButtonGroupOutside={true}
      >
        {eventsData.map(({ node }) => {
          return (
            <EventsItem key={node.drupal_id} className={eventsItem}>
              <EvenementContent evenement={node} />
            </EventsItem>
          )
        })}
      </MultiCarousel>
    </>
  )
}

const CustomRightArrow = ({ onClick }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <CustomArrows
      className={`${carouselArrowRight} ${eventsCarouselArrowRight}`}
      onClick={() => onClick()}
    />
  )
}
const CustomLeftArrow = ({ onClick }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <CustomArrows
      className={`${carouselArrowLeft} ${eventsCarouselArrowLeft}`}
      onClick={() => onClick()}
    />
  )
}

RenderEvenements.propTypes = {
  eventsData: PropTypes.array.isRequired,
}

CustomRightArrow.propTypes = {
  onClick: PropTypes.func,
}

CustomLeftArrow.propTypes = {
  onClick: PropTypes.func,
}

export default RenderEvenements
